import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { forwardRef, useLayoutEffect, useRef } from 'react';
import { BlockLastSearches } from '../../../../components/SearchForm/components/DestinationWidget/components/BlockLastSearches/index.js';
import { BlockLinks } from '../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/index.js';
import { BlockSearchResults } from '../../../../components/SearchForm/components/DestinationWidget/components/BlockSearchResults/index.js';
import { List } from '../../../../components/SearchForm/components/DestinationWidget/components/List/index.js';
import { Alert } from '../../../../primitives/index.js';
import { qaId } from '../../../../utils/index.js';
import { SEARCH_FORM_QA_ID } from '../../../../utils/qaId.js';
export const DestinationWidget = forwardRef(function DestinationWidget({
  type,
  open,
  searchTerm,
  destinations,
  hasNoResultMessage,
  widgetHead,
  invalid,
  selectedIndex,
  onSelectTopDestination,
  onClose,
  recentSearches = false,
  onClear,
  highlightedIndex,
  getInputProps,
  getMenuProps,
  getItemProps,
  layout,
  onClickLastSearchesItem,
  airportsConfig,
  templateItems,
  travelType,
  ...restProps
}, ref) {
  const {
    t
  } = useTranslation();
  const inputRef = useRef(null);
  // Force destination field focus in compact layout
  useLayoutEffect(() => {
    if (!inputRef?.current || type === 'drawer') {
      return;
    }
    inputRef.current.focus();
  }, []);
  const isShowing = destinations.length === 0;
  return _jsxs(List, {
    searchTerm: searchTerm,
    onClose: onClose,
    type: type,
    invalid: invalid,
    open: open,
    layout: layout,
    getInputProps: getInputProps,
    onClear: onClear,
    widgetHead: widgetHead,
    containerRef: ref,
    ...restProps,
    children: [invalid && _jsx(Alert, {
      variant: "warning",
      caption: t('searchField:noDestination'),
      "data-testid": qaId(SEARCH_FORM_QA_ID, 'trackingAcNoResult')
    }), hasNoResultMessage && _jsx(Alert, {
      caption: t('searchField:noMatchingDestination'),
      "data-testid": qaId(SEARCH_FORM_QA_ID, 'trackingAcEmpty')
    }), templateItems.map((contentItems, index) => {
      if (!contentItems) {
        return null;
      }
      const {
        item,
        collection
      } = contentItems;
      const key = `${collection}-${index}`;
      if (collection === 'block_searchform_links' && isShowing) {
        return _jsx(BlockLinks, {
          item: item,
          onSelectKeyword: onSelectTopDestination
        }, key);
      }
      if (travelType !== 'holidayHomes' && collection === 'block_last_searches' && isShowing && recentSearches) {
        return _jsx(BlockLastSearches, {
          onClickItem: onClickLastSearchesItem,
          config: airportsConfig
        }, key);
      }
      if (collection === 'block_search_results' && destinations.length > 0) {
        return _jsx(BlockSearchResults, {
          destinations: destinations,
          getItemProps: getItemProps,
          getMenuProps: getMenuProps,
          highlightedIndex: highlightedIndex,
          selectedIndex: selectedIndex,
          searchTerm: searchTerm
        }, key);
      }
      return null;
    })]
  });
});